module.exports = __webpack_public_path__ + "img/tu9@2x.4b69dcda.png";